import { t } from '@/i18n'
import { utils } from 'xlsx'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'

export function exportPBDStats(title, range, filter, search, data) {
  let txtMetaFile = ''
  if (title) txtMetaFile += t('add_title') + ': ' + title + '\n'
  if (range) txtMetaFile += t('add_range') + ': ' + range + '\n'
  if (filter) txtMetaFile += t('add_filter') + ': ' + filter + '\n'
  if (search) txtMetaFile += t('add_search') + ': ' + search + '\n'

  //txtMetaFile done
  let parsedDataCard = data ? data : []
  // let parseHed
  // tableData.header.forEach(hed => {
  //   parseHed = []
  //   hed.forEach(el => {
  //     if (el.colSpan > 1) {
  //       let partialHed = []
  //       for (let i = 0; i < el.colSpan; i++) {
  //         partialHed.push(el.label)
  //       }
  //       parseHed = parseHed.concat(partialHed)
  //     } else if (!el.isEmptyCol) parseHed.push(el.label)
  //   })
  //   parsedDataCard.push(parseHed)
  // })

  // let arrayEmptyCols = tableData.header[tableData.header.length - 1].map(el => el.isEmptyCol)
  // let parsedValues
  // tableData.values.forEach(el => {
  //   parsedValues = []
  //   el.forEach((elem, ind) => {
  //     if (!arrayEmptyCols[ind]) parsedValues.push(elem ? (elem.label ? elem.label : elem) : '-')
  //   })
  //   parsedDataCard.push(parsedValues)
  // })

  let zip = new JSZip()
  const ws = utils.aoa_to_sheet(parsedDataCard)
  //const ws = utils.json_to_sheet(parsedDataCard)

  //CONVERSION TO EXCEL

  //const wb = utils.book_new()
  //utils.book_append_sheet(wb, ws, 'Data')
  //writeFileXLSX(wb, 'SheetJSVue.xlsx')
  //zip.file(t('file_table') + '.xlsx', write(wb, { bookType: 'xlsx', type: 'buffer' }))

  const fileCsv = utils.sheet_to_csv(ws, { FS: ',' })
  const blo = new Blob([fileCsv], { type: 'text/plain;charset=UTF-8' })

  zip.file(t('STATISTICS') + '.csv', blo)
  zip.file('Metadata.txt', txtMetaFile)
  zip.generateAsync({ type: 'blob' }).then(function (blob) {
    saveAs(blob, title + '.zip')
  })
}
